import { Component, Input } from '@angular/core';

@Component({
  selector: 'cinch-icon',
  templateUrl: './icons.component.html',
  styleUrl: './icons.component.scss'
})
export class IconsComponent {
  @Input() icon:string = "info";
  @Input() theme:string = "primary";
}
